import axios from 'axios';
import { default as config } from '../../constants/constants';

export function updateDiscoveryDocumentsSearchValue(
  discoveryDocumentsSearchValue
) {
  return {
    type: 'UPDATE_DISCOVERY_DOCUMENTS_SEARCH_VALUE',
    discoveryDocumentsSearchValue
  };
}

export function resetDiscoveryDocumentsSearchValue() {
  return {
    type: 'RESET_DISCOVERY_DOCUMENTS_SEARCH_VALUE'
  };
}

export function increaseDiscoveryDocumentsPage() {
  return {
    type: 'INCREASE_DISCOVERY_DOCUMENTS_PAGE'
  };
}

export function resetDiscoveryDocumentsPage() {
  return {
    type: 'RESET_DISCOVERY_DOCUMENTS_PAGE'
  };
}

export function updateDocumentsSearchValue(documentsSearchValue) {
  return {
    type: 'UPDATE_DOCUMENTS_SEARCH_VALUE',
    documentsSearchValue
  };
}

export function resetDocumentsSearchValue() {
  return {
    type: 'RESET_DOCUMENTS_SEARCH_VALUE'
  };
}

export function increaseDashboardDocumentsPage() {
  return {
    type: 'INCREASE_DASHBOARD_DOCUMENTS_PAGE'
  };
}

export function resetDashboardDocumentsPage() {
  return {
    type: 'RESET_DASHBOARD_DOCUMENTS_PAGE'
  };
}

export function updateDashboardPodcastsPage() {
  return {
    type: 'INCREASE_DASHBOARDS_PODCAST_PAGE'
  };
}

export function resetDashboardPodcastsPage() {
  return {
    type: 'RESET_DASHBOARDS_PODCAST_PAGE'
  };
}

export function fetchDocuments(token) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/documents`
  };
  return {
    type: 'FETCH_DOCUMENTS',
    payload: axios(options)
  };
}

export function fetchLast5ListenedDocuments(token) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/episodes?listened=true&includeAll=true&pageSize=5`
  };
  // Debug log for API call
  console.log('[fetchLast5ListenedDocuments] API options:', options);
  
  return {
    type: 'FETCH_LAST_5_LISTENED_DOCUMENTS',
    payload: axios(options)
  };
}

export function fetchFlags(token) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/notes?subscribedPodcast=true&pageSize=5`
  };
  return {
    type: 'FETCH_FLAGS',
    payload: axios(options)
  };
}

export function fetchDocumentsByPodcastDbIds(token, ids) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/episodes?podcast=${ids}`
  };
  return {
    type: 'FETCH_DOCUMENTS_BY_PODCASTDBID',
    payload: axios(options)
  };
}

export function updatePodcastDataAfterFetch(payload) {
  return {
    type: 'FETCH_SUBSCRIBED_PODCASTS',
    payload
  };
}

export function fetchFlagsByPodcastId(token, id) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/notes?podcastId=${id}`
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject({ err });
        //console.error(err)
      });
  });
}

export function updateFlagsByPodcastId(payload) {
  return {
    type: 'FETCH_FLAGS_BY_PODCASTID',
    payload
  };
}

export function resetDocuments() {
  return {
    type: 'RESET_DOCUMENTS',
    payload: null
  };
}

export function fetchPodcastsWithFlags(token) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/podcasts?notesCount=gt0&includeAll=true`
  };
  return {
    type: 'FETCH_PODCASTS_WITH_FLAGS',
    payload: axios(options)
  };
}

export function fetchDocumentsWithFlags(token) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/episodes?notesCount=gt0`
  };
  return {
    type: 'FETCH_DOCUMENTS_WITH_FLAGS',
    payload: axios(options)
  };
}

export function fetchTemplate(token) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/templates`
  };
  return {
    type: 'FETCH_TEMPLATE',
    payload: axios(options)
  };
}

export function testEmail(token, htmlCode) {
  const options = {
    method: 'PUT',
    headers: { 'X-Firebase-Auth': token, 'content-type': 'text/html' },
    url: `${config.serverURL}/templates/testEmail`,
    data: htmlCode
  };
  return {
    type: 'TEST_EMAIL',
    payload: axios(options)
  };
}

export function updateTag(token, tagRequest) {
  const options = {
    method: 'PUT',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/tags`,
    data: tagRequest
  };
  return {
    type: 'UPDATE_TAG',
    payload: axios(options)
  };
}

export function updateDocument(token, values) {
  const options = {
    method: 'POST',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/episodes`,
    data: values
  };

  return {
    type: 'UPDATE_DOCUMENT',
    payload: axios(options)
  };
}

export function updateDocumentProgress(document, progress) {
  return {
    type: 'UPDATE_DOCUMENT_PROGRESS',
    meta: { document, progress }
  };
}

export function initializePodcasts(urls) {
  return {
    type: 'INIT_PODCASTS',
    meta: { urls }
  };
}

export function validatePodcast(
  url,
  token,
  uuid,
  username = null,
  password = null
) {
  const serverUrl = `${
    config.serverURL
  }/rss/returnRssFeed?url=${encodeURIComponent(url)}`;
  const extendUrl =
    username && password
      ? `&username=${encodeURIComponent(
          username
        )}&password=${encodeURIComponent(password)}`
      : '';

  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    timeout: 60000,
    url: `${serverUrl}${extendUrl}`
  };

  return {
    type: 'VALIDATE_PODCAST',
    payload: axios(options),
    meta: { uuid, url, username, password }
  };
}

export function postRssFeed(values, token, url, username, password) {
  const extendUrl =
    username && password
      ? `username=${encodeURIComponent(username)}&password=${encodeURIComponent(
          password
        )}`
      : '';

  const options = {
    method: 'POST',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/podcasts?${extendUrl}`,
    data: values
  };

  return {
    type: 'POST_RSS_FEED',
    payload: axios(options),
    meta: { url }
  };
}

export function postOpml(formData, token) {
  const options = {
    method: 'POST',
    headers: {
      'X-Firebase-Auth': token,
      'Content-Type': 'multipart/form-data'
    },
    url: `${config.serverURL}/opml`,
    timeout: 30000,
    data: formData
  };

  return {
    type: 'POST_OPML',
    payload: axios(options)
  };
}

export function deletePodcasts(values) {
  return {
    type: 'DELETE_RSS',
    payload: values
  };
}

export function updatePodcastName(podcast) {
  return {
    type: 'UPDATE_RSS_NAME',
    payload: podcast
  };
}

export function resetRssFeed() {
  return {
    type: 'RESET_RSS_FEED'
  };
}

export function addFlag(token, values, success, error) {
  const options = {
    method: 'POST',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/notes?flashnote=${false}`,
    data: values
  };

  const request = axios(options);
  request.then(() => success()).catch((e) => error(e));

  return {
    type: 'ADD_FLAG',
    payload: request
  };
}

export function addDocument(token, values, success, error) {
  const options = {
    method: 'POST',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/documents`,
    data: values
  };

  const request = axios(options);
  request.then(() => success()).catch((e) => error(e));

  return {
    type: 'ADD_DOCUMENT',
    payload: request
  };
}

export function fetchPlaylists(token) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/playlists/?includeAll=true`
  };

  return new Promise((resolve, reject) => {
    axios(options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject({ err });
        //console.error(err)
      });
  });
}

export function updatePlaylistDataAfterFetch(payload) {
  return {
    type: 'FETCH_PLAYLISTS',
    payload
  };
}

export function updateUserFields(token, values) {
  const options = {
    method: 'PUT',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/users/updateUserFields`,
    data: values
  };

  const request = axios(options);
  return {
    type: 'UPDATE_USER_FIELDS',
    payload: request
  };
}

//return a list of podcast with info about num of new documents
export function fetchNewDocuments(token) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/documents/new`
  };

  return new Promise((resolve, reject) => {
    axios(options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject({ err });
        //console.error(err)
      });
  });
}

export function updateNewDocumentsDataAfterFetch(payload) {
  return {
    type: 'FETCH_NEW_DOCUMENTS',
    payload
  };
}

export function setPlayingDocumentId(payload) {
  return {
    type: 'SET_PLAYING_DOCUMENT_ID',
    payload
  };
}

export function setListeningToDocument(payload) {
  return {
    type: 'SET_LISTENING_TO_DOCUMENT',
    payload
  };
}

export function setPlaybackPlaylists(payload) {
  return {
    type: 'SET_PLAYBACK_PLAYLIST',
    payload
  };
}

export function fetchCategoriesWithPodcasts(token, forceReload) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/podcasts/discover${
      forceReload ? '?forceReload=true' : ''
    }`
  };

  return new Promise((resolve, reject) => {
    axios(options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject({ err });
        //console.error(err)
      });
  });
}

export function updateCategoriesWithPodcastsDataAfterFetch(payload) {
  return {
    type: 'FETCH_CATEGORIES_PODCASTS',
    payload
  };
}

export function fetchSearchPodcasts(token, value, optionProps) {
  const options = {
    method: 'POST',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/podcasts/discover/search?searchTerm=${value}`,
    optionProps
  };

  return new Promise((resolve, reject) => {
    axios(options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject({ err });
      });
  });
}

// not used
export function updateSearchPodcastsDataAfterFetch(payload) {
  return {
    type: 'FETCH_SEARCH_PODCASTS',
    payload
  };
}

export function subscribe(values, token) {
  const options = {
    method: 'POST',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/podcasts/subscribe?`,
    data: values
  };

  return {
    type: 'SUBSCRIBE_PODCAST',
    payload: axios(options)
  };
}

export function setPlayingFromListenNowPlaylist(payload) {
  return {
    type: 'SET_PLAYING_FROM_LISTEN_NOW_PLAYLIST',
    payload
  };
}

export function setDocumentInListenNowHasFullProgress(payload) {
  return {
    type: 'SET_DOCUMENT_IN_LISTEN_NOW_HAS_FULL_PROGRESS',
    payload
  };
}

export function resetLast5ListenedDocuments() {
  return {
    type: 'RESET_LAST_5_LISTENED_DOCUMENTS',
    payload: []
  };
}

export function fetchSearchPodcastsByCategory(token, value, optionProps) {
  const options = {
    method: 'POST',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/podcasts/discover/searchByCategory?categoryId=${value}`,
    ...optionProps
  };

  return new Promise((resolve, reject) => {
    axios(options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject({ err });
      });
  });
}

// not used
export function updateSearchPodcastsByCategoryDataAfterFetch(payload) {
  return {
    type: 'FETCH_SEARCH_PODCASTS_BY_CATEGORY',
    payload
  };
}

export function fetchUserFields(token, name) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url:
      name !== undefined
        ? `${config.serverURL}/users/getUserFields?keyName=${name}`
        : `${config.serverURL}/users/getUserFields`
  };
  return {
    type: 'FETCH_USER_FIELDS',
    payload: axios(options)
  };
}

export function resetApp() {
  return {
    type: 'RESET_APP'
  };
}

export const fetchUserGroups = (token, feedUrl) => {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/usergroup/getUserGroups?feedUrl=${feedUrl}`
  };
  return {
    type: 'FETCH_USER_GROUPS',
    payload: axios(options)
  };
};

export const userGroupSearchUsers = (token, feedUrl, searchQuery) => {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/usergroup/searchUsers?feedUrl=${feedUrl}&search=${searchQuery}`
  };
  return {
    type: 'USER_GROUPS_SEARCH_USERS',
    payload: axios(options)
  };
};

export function setPlaybackFlags(playbackFlags) {
  return {
    type: 'SET_PLAYBACK_FLAGS',
    payload: playbackFlags
  };
}

export const userGroupShareFlag = (
  token,
  flagId,
  comment,
  userGroupsId,
  usersId
) => {
  const options = {
    method: 'POST',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/usergroup/shareNote?noteId=${flagId}&comment=${comment}`,
    data: {
      userGroupIds: userGroupsId,
      userIds: usersId
    }
  };

  return {
    type: 'USER_GROUP_SHARE_FLAG',
    payload: axios(options)
  };
};

export const handleIsSharingFlag = (isSharing) => {
  return {
    type: 'USER_GROUP_IS_SHARING_EVENT',
    payload: isSharing
  };
};

export const createUserGroup = (token, groupName, feedUrl, groupUsers) => {
  const options = {
    method: 'POST',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/usergroup/createUserGroup?groupName=${groupName}`,
    data: {
      feedUrl,
      users: groupUsers
    }
  };

  return {
    type: 'USER_GROUP_CREATE_GROUP',
    payload: axios(options)
  };
};

export const handleCreatingGroupAction = (inAction) => {
  return {
    type: 'USER_GROUP_CREATING_EVENT',
    payload: inAction
  };
};

export const handleInCreatingAndSharingFlagAction = (inAction) => {
  return {
    type: 'USER_GROUP_CREATING_AND_SHARING_EVENT',
    payload: inAction
  };
};

export function fetchNotifications(token) {
  const options = {
    method: 'GET',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/notifications`
  };
  return {
    type: 'FETCH_NOTIFICATIONS',
    payload: axios(options)
  };
}

export function deleteNotification(token, ids) {
  const options = {
    method: 'DELETE',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/notifications?ids=${ids}`
  };
  return {
    type: 'DELETE_NOTIFICATION',
    payload: axios(options)
  };
}

export const deleteFlag = async (token, flagId) => {
  const options = {
    method: 'DELETE',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/notes?noteId=${flagId}`
  };

  // return {
  //     type: "DELETE_FLAG",
  //     payload: axios(options)
  // }
  try {
    const response = await axios(options);
    if (response) {
      return {
        successMessage: 'OK'
      };
    }
  } catch (error) {
    if (
      error.response?.data?.response?.includes(
        'DataIntegrityViolationException'
      )
    ) {
      return {
        errorMessage:
          'Flag could not be deleted because it is already shared with other groups or users.'
      };
    }
  }
};

export const deleteFlags = async (token, flagIds) => {
  const options = {
    method: 'DELETE',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/notes/deleteAllByIds`,
    data: {
      noteIds: flagIds // keep as noteIds for API compatibility
    }
  };

  try {
    const response = await axios(options);
    if (response) {
      return {
        successMessage: 'OK'
      };
    }
  } catch (error) {
    if (error.response.data.response?.includes('notification_note_id_fkey')) {
      return {
        errorMessage: `${
          flagIds.length > 1 ? 'Flags' : 'Flag'
        } could not be deleted because ${
          flagIds.length > 1 ? 'they have' : 'it has'
        } already shared with other groups or users.`
      };
    }
  }
};

export const fetchUsersAndUserGroups = (
  feedUrl,
  searchQuery,
  token,
  flagId,
  comment,
  userGroupsId,
  usersId
) => {
  const options = {
    method: 'POST',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/usergroup/shareNote?noteId=${flagId}&comment=${comment}`,
    data: {
      userGroupIds: userGroupsId,
      userIds: usersId
    }
  };
  return {
    type: 'FETCH_USERS_AND_USER_GROUPS',
    payload: axios(options)
  };
};
